import { useEffect, useState } from 'react';

/** Bounds in layout CSS pixels, including Safari's pan when focusing a field. */
export const useDialogViewport = (enabled: boolean) => {
  const [bounds, setBounds] = useState<{ height: number; top: number } | null>(null);

  useEffect(() => {
    if (!enabled) return;
    const viewport = window.visualViewport;
    const update = () => {
      // Keep normal browser zoom: zooming is not an on-screen keyboard resize.
      if (viewport && viewport.scale != null && viewport.scale !== 1) {
        setBounds(null);
        return;
      }
      const height = viewport?.height ?? window.innerHeight;
      if (height <= 0) return;
      setBounds({ height, top: viewport?.offsetTop ?? 0 });
    };
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [enabled]);

  return enabled ? bounds : null;
};
